var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWire = function SvgWire(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_1060)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FFF28C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14_1060",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14_1060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.916 19H10.4268L10.2656 13.7656L7.6582 19H6.13965L5.87109 11.8418H7.31152L7.375 16.8516L9.83105 11.8418H11.4277L11.5938 16.7979L13.9521 11.8418H15.3779L11.916 19ZM15.9492 11.8418H17.3506L17.0869 13.1113H15.6855L15.9492 11.8418ZM15.5391 13.8145H16.9404L15.8564 19H14.4551L15.5391 13.8145ZM18.2441 13.8145H19.5527L19.3428 14.8203C19.8311 14.0684 20.36 13.6924 20.9297 13.6924C21.1315 13.6924 21.348 13.7428 21.5791 13.8438L21.042 14.9912C20.915 14.9456 20.7799 14.9229 20.6367 14.9229C20.3958 14.9229 20.1501 15.014 19.8994 15.1963C19.652 15.3786 19.4583 15.6227 19.3184 15.9287C19.1784 16.2314 19.04 16.7132 18.9033 17.374L18.5615 19H17.1602L18.2441 13.8145ZM26.1836 16.8418H22.668C22.6647 16.8971 22.6631 16.9395 22.6631 16.9688C22.6631 17.3138 22.7607 17.5921 22.9561 17.8037C23.1546 18.0153 23.3955 18.1211 23.6787 18.1211C24.1442 18.1211 24.5072 17.8802 24.7676 17.3984L26.0225 17.6084C25.7783 18.113 25.4512 18.4922 25.041 18.7461C24.6341 18.9967 24.1768 19.1221 23.6689 19.1221C22.9723 19.1221 22.4059 18.9023 21.9697 18.4629C21.5335 18.0202 21.3154 17.4359 21.3154 16.71C21.3154 16.0003 21.5124 15.3688 21.9062 14.8154C22.4434 14.0667 23.21 13.6924 24.2061 13.6924C24.8408 13.6924 25.3454 13.8893 25.7197 14.2832C26.0941 14.6738 26.2812 15.2223 26.2812 15.9287C26.2812 16.2673 26.2487 16.5716 26.1836 16.8418ZM25.002 15.9873C25.0052 15.9255 25.0068 15.8783 25.0068 15.8457C25.0068 15.4616 24.9206 15.1735 24.748 14.9814C24.5755 14.7894 24.3444 14.6934 24.0547 14.6934C23.765 14.6934 23.5046 14.8024 23.2734 15.0205C23.0456 15.2386 22.891 15.5609 22.8096 15.9873H25.002Z",
    fill: "#4D4408"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_1060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWire);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wire.8103178c.svg";